import { render, staticRenderFns } from "./UserConsecutiveShifts.vue?vue&type=template&id=2c570a74&"
import script from "./UserConsecutiveShifts.vue?vue&type=script&lang=js&"
export * from "./UserConsecutiveShifts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c570a74')) {
      api.createRecord('2c570a74', component.options)
    } else {
      api.reload('2c570a74', component.options)
    }
    module.hot.accept("./UserConsecutiveShifts.vue?vue&type=template&id=2c570a74&", function () {
      api.rerender('2c570a74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scheduling/validators/consecutive_shifts/UserConsecutiveShifts.vue"
export default component.exports